import mainHero from "@/assets/images/hero/main-hero.jpg";
import healthyToenails from "@/assets/images/hero/healthy-toenails.jpg";
import oreganoOil from "@/assets/images/products/oregano-oil.jpg";
import wellanailProduct from "@/assets/images/products/wellanail-anti-fungal-stick.jpg";
import wellanailHero from "@/assets/images/products/wellanail-hero.jpg";
import fortifyxOil from "@/assets/images/products/fortifyx-oregano-oil.jpg";
import topicalSolutions from "@/assets/images/products/topical-solutions.jpg";
import antifungalSprays from "@/assets/images/products/antifungal-sprays.jpg";
import comparisonTable from "@/assets/images/products/comparison-table.jpg";
import wellanailProductShot from "@/assets/images/products/wellanail-product-shot.jpg";
import productDetail1 from "@/assets/images/products/product-detail-1.jpg";
import productDetail2 from "@/assets/images/products/product-detail-2.jpg";
import toenails from "@/assets/images/products/toenails-01.webp";
import wellanailOrder from "@/assets/images/products/wellanail-order.jpg";

import mariaZ from "@/assets/images/testimonials/maria-z.jpg";
import josephT from "@/assets/images/testimonials/joseph-t.jpg";
import deannaS from "@/assets/images/testimonials/deanna-s.png";

import checkmark from "@/assets/images/icons/checkmark.png";
import cross from "@/assets/images/icons/cross.png";

export const ASSETS = {
  hero: {
    mainHero,
    healthyToenails,
  },
  products: {
    wellanailProduct,
    wellanailHero,
    fortifyxOil,
    topicalSolutions,
    antifungalSprays,
    comparisonTable,
    wellanailOrder,
    wellanailProductShot,
    productDetail1,
    productDetail2,
    toenails,
    oreganoOil,
  },
  testimonials: {
    mariaZ,
    josephT,
    deannaS,
  },
  icons: {
    checkmark,
    cross,
  },
} as const;
